const buildDefaultAttributes = (controlType, index) => {
  // tabindex is used to disable certain bootstrap styling which has 'not' selectors on tabindex
  return `${index !== undefined ? `data-index="${index}"` : ''} data-type="${controlType}" tabindex="0"`
}
export default buildDefaultAttributes
